module.exports = __webpack_public_path__ + "static/media/microphone_access_firefox.160431fc.gif";